<!-- 
	This is the illustration sign up page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
	<div class="sign-in">

		<a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle" class="row-main">

			<!-- Login Form Column -->
			<a-col class="col-form">
				<h4 class="mb-15">Login</h4>
				<p class="text-muted">Enter your username and password to login</p>

				<!-- Sign Form -->
				<div v-if="errorMessage" class="error-message">
					{{ errorMessage }}
				</div>
				<a-form id="components-form-demo-normal-login" :form="form" class="login-form" @submit="handleSubmit"
					:hideRequiredMark="true">
					<a-form-item class="mb-10" label="username" :colon="false">
						<a-input id="username" v-decorator="[
							'username',
							{ rules: [{ required: true, message: 'Please input your username!' }] },
						]" placeholder="username" />
					</a-form-item>
					<a-form-item class="mb-5" label="Password" :colon="false">
						<a-input id="password" v-decorator="[
							'password',
							{ rules: [{ required: true, message: 'Please input your password!' }] },
						]" type="password" placeholder="Password" />
					</a-form-item>
					<a-form-item>
						<a-button type="primary" block html-type="submit" class="login-form-button" :disabled="isLoading"
							:loading="isLoading">
							Login
						</a-button>
					</a-form-item>
				</a-form>
			</a-col>
		</a-row>
		<a-row type="flex" :gutter="[24, 24]" justify="space-around" align="middle" class="row-main">
			<span>Don't have an account?</span>
				<a-button @click="toRegisterPage()">Register</a-button>
		</a-row>
	</div>
</template>

<script>
import router from "@/router";

export default {
	data() {
		return {
			form: this.$form.createForm(this, { name: "Login_illustration" }),
			isLoading: false,
			errorMessage: null,
		};
	},
	methods: {
		handleSubmit(e) {
			e.preventDefault();
			this.form.validateFields((err, values) => {
				if (!err) {
					this.isLoading = true;
					this.$store
						.dispatch("user/login", {
							Username: values.username,
							Password: values.password,
						})
						.then(() => {
							if (this.user.success) {
								this.isLoading = false;
								router.push("/dashboards");
							} else {
								this.isLoading = false;
								this.errorMessage = "Incorrect Username or Password";
								console.error("Login Error:", error);
							}
						})
						.catch((error) => {
							this.isLoading = false;
							this.errorMessage = "Incorrect Username or Password";
							console.error("Login Error:", error);
						});
				}
			});
		},
		toRegisterPage() {
			router.push("/register");
		}
	},
	computed: {
		user: {
			get() {
				return this.$store.state.user.user;
			}
		},
	},
};
</script>

<style>
.error-message {
	color: red;
	margin-bottom: 10px;
}
</style>